// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(() => {
    const stored = localStorage.getItem('calibza_user');
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('calibza_token');
    if (token && !user) {
      authApi.me()
        .then(r => { setUser(r.data); localStorage.setItem('calibza_user', JSON.stringify(r.data)); })
        .catch(() => { localStorage.removeItem('calibza_token'); localStorage.removeItem('calibza_user'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await authApi.login({ email, password });
    localStorage.setItem('calibza_token', data.token);
    localStorage.setItem('calibza_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem('calibza_token');
    localStorage.removeItem('calibza_user');
    setUser(null);
  };

  const isHR      = user?.role === 'hr_admin' || user?.role === 'super_admin';
  const isManager = user?.role === 'manager'  || isHR;

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isHR, isManager }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
